let commonCatalogDetail = null

const initShareSocial = (network) => {
    const url = encodeURIComponent(window.location.href)
    const itemNameElement = commonCatalogDetail.querySelector('.item-name')
    const text = itemNameElement ? encodeURIComponent(itemNameElement.textContent) : ''

    const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&text=${text}`,
        x: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    }

    const shareUrl = shareUrls[network]

    if (shareUrl) {
        window.open(shareUrl, '_blank')
    }
}

document.addEventListener('DOMContentLoaded', () => {
    commonCatalogDetail = document.querySelector('.common-catalog.detail')
    if (commonCatalogDetail) {
        commonCatalogDetail.querySelector('.share-on-social').addEventListener('click', (e) => {
            e.preventDefault()
            if (e.target.dataset.network) {
                initShareSocial(e.target.dataset.network)
            }
        })
    }
})
